import { DirtLevelEnum } from 'api';
import { SelectField, SelectFieldProps, SelectOption } from 'form';
import { translate } from 'i18n';

type MaterialDirtLevelProps = Omit<SelectFieldProps, 'options'>;

const MaterialDirtLevelDisplayedOptions: SelectOption[] = [
  {
    label: translate('backlog.materialDirtLevel.options.veryClean', { namespace: 'features' }),
    value: DirtLevelEnum.VC,
  },
  {
    label: translate('backlog.materialDirtLevel.options.clean', { namespace: 'features' }),
    value: DirtLevelEnum.CL,
  },
  {
    label: translate('backlog.materialDirtLevel.options.dirty', { namespace: 'features' }),
    value: DirtLevelEnum.DI,
  },
  {
    label: translate('backlog.materialDirtLevel.options.notAvailable', { namespace: 'features' }),
    value: 'n/a',
  },
];

export const MaterialDirtLevel = ({ label, name, ...rest }: MaterialDirtLevelProps) => {
  return (
    <SelectField
      label={label}
      name={name}
      type="text"
      options={MaterialDirtLevelDisplayedOptions}
      required={false}
      {...rest}
    />
  );
};
